module.exports = __webpack_public_path__ + "static/media/vacation-for-yourself-mob.fdfd041b.jpg";